<template>
  <v-dialog v-model="isViewNotification" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        plain
        class="btn-noti ml-3"
        v-bind="attrs"
        v-on="on"
        @click="isViewNotification = !isViewNotification"
        :disabled="!wsInfo"
        height="50"
        elevation="0"
      >
        <span class="material-icons-round btn-text" style="font-size: 30px; font-weight: 400" translate="no">
          notifications
        </span>
        <span class="btn-text-status mt-1">{{ statusNoti }}</span>
      </v-btn>
    </template>
    <v-card style="background-color: #21343b">
      <v-row no-gutters style="justify-content: space-between" class="px-6 py-5">
        <v-col cols="9" align="start">
          <span class="txt-section-title ml-2">{{ 'Who should we notify?' }}</span>
        </v-col>
        <v-col cols="3" align="end">
          <v-btn dark elevation="0" icon @click="isViewNotification = !isViewNotification">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="px-5 pt-1" style="background-color: #21343b; overflow-y: auto; overflow-x: hidden">
        <v-col cols="12">
          <v-card elevation="0" dark style="border-radius: 20px">
            <v-row class="container-find-user" no-gutters>
              <v-combobox
                v-model="model"
                :filter="filter"
                :items="memberData"
                :hide-no-data="!search"
                :search-input.sync="search"
                :loading="isLoading"
                hide-selected
                label="Add people, or emails ..."
                multiple
                hide-details="auto"
                solo
                chips
                clearable
                background-color="#1a272e"
                class="container-combobox"
                style="padding: 10px 3px; border-radius: 20px"
                :error="comboboxError.status"
                :error-messages="comboboxError.message"
              >
                <template v-slot:no-data>
                  <v-list-item dark style="color: #aaa">
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ search }}</strong>
                        ".
                      </v-list-item-title>
                      <v-list-item-title>
                        Press
                        <kbd>enter</kbd>
                        to create an email notification.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip v-if="item === Object(item)" v-bind="attrs" :input-value="selected" label dark>
                    <v-avatar
                      :color="item.userDisplayName || item.userFullName | iconBackground"
                      class="logo mr-1"
                      round
                      size="20"
                      style="cursor: pointer"
                    >
                      <span
                        v-if="!item.userPicture"
                        style="color: #ffffff; font-size: 13px; text-align: center; font-weight: bold"
                      >
                        {{ item.userDisplayName || item.userFullName | iconFilter }}
                      </span>
                      <v-img :src="item.userPicture" v-else />
                    </v-avatar>
                    <span class="pr-2">
                      {{ item.userDisplayName || item.userFullName }}
                    </span>
                    <v-icon small @click="parent.selectItem(item), select()">$delete</v-icon>
                  </v-chip>
                </template>

                <template v-slot:item="{ index, item }">
                  <v-chip :key="item.index" dark label @click="select(index)">
                    <v-avatar
                      :color="item.userDisplayName || item.userFullName | iconBackground"
                      class="logo mr-1"
                      round
                      size="20"
                      style="cursor: pointer"
                    >
                      <span
                        v-if="!item.userPicture"
                        style="color: #ffffff; font-size: 13px; text-align: center; font-weight: bold"
                      >
                        {{ item.userDisplayName || item.userFullName | iconFilter }}
                      </span>
                      <v-img :src="item.userPicture" v-else />
                    </v-avatar>
                    {{ item.userDisplayName || item.userFullName }}
                  </v-chip>
                </template>
              </v-combobox>
            </v-row>
          </v-card>
        </v-col>

        <v-col v-if="this.wsInfo" cols="12" class="container-checkbox">
          <v-checkbox
            dark
            v-model="chkboxWs"
            :label="'Everyone at ' + this.wsInfo.wsName"
            color="#27cd8b"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" class="container-checkbox mb-2">
          <v-checkbox
            dark
            v-model="chkboxPostComment"
            :label="'Who posted clips, comments in this meeting'"
            color="#27cd8b"
            hide-details
          ></v-checkbox>
        </v-col>

        <v-col cols="12" class="container-checkbox mt-2 mb-1" align="center">
          <v-btn plain dark @click="removeAll" style="text-decoration: underline">
            <span style="font-weight: 400; font-size: 14px">{{ 'Click to remove all' }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="btn-bottom px-8 py-5" align="start" justify="center">
        <v-col cols="6" align-self="center" align="start">
          <v-btn width="95%" height="40" elevation="0" color="#869399" @click="undo">
            {{ 'Undo' }}
          </v-btn>
        </v-col>
        <v-col cols="6" align-self="center" align="end">
          <v-btn width="95%" height="40" elevation="0" color="#289067" @click="close">{{ $t('confirm') }}</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { getTargetList } from '@/services/meetingApi'
import { regExpTest } from '@/common/lib/strLib'
export default {
  name: 'NotificationDialog',
  props: {},
  data() {
    return {
      selectNoti: 'none',
      search: '',
      memberList: [],
      memberData: [],
      isViewNotification: false,
      isLoading: false,
      attendeeKey: 0,
      chkboxWs: true,
      chkboxPostComment: true,
      model: [],
      initialValue: {
        model: [],
        chkboxWs: null,
        chkboxPostComment: null,
      },
      comboboxError: {
        status: false,
        message: null,
      },
    }
  },
  created() {
    this.getMember()
  },
  mounted() {
    // 프라이빗 채널의 기본값 지정
    if (this.mtInfo.mtPermission == 'private') {
      this.chkboxWs = false
    }
  },
  methods: {
    async getMember() {
      this.isLoading = true
      try {
        let ctx = this
        let userInfo

        let result = await getTargetList(this, this.mtInfo.mtId, this.userInfo.userId, false)
        this.memberList = result.mtTargetList
        if (this.memberList && this.memberList !== null && ctx.mtInfo) {
          userInfo = this.memberList.find((user) => user.userId === ctx.mtInfo.mtOrganizerUid)
          if (userInfo && userInfo !== null) this.memberList.splice(this.memberList.indexOf(userInfo), 1)
          this.memberList.unshift(userInfo)
        }
        this.setList()
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    setList() {
      this.memberData = []
      this.memberList.forEach((value) => {
        if (value.userId == this.userInfo.userId) return
        const member = {}
        member.userId = value.userId
        member.userDisplayName = value.userDisplayName
        member.userFullName = value.userFullName
        member.userPicture = value.userPicture
        member.userEmail = value.userEmail
        member.text = member.userDisplayName || member.userFullName
        this.memberData.push(member)
      })
    },
    select() {
      this.attendeeKey += 1 // 아바타 그림 다시 그려주기 위한 트리거
    },
    undo() {
      this.model = this.initialValue.model
      this.chkboxWs = this.initialValue.chkboxWs
      this.chkboxPostComment = this.initialValue.chkboxPostComment
      this.emit()
      this.isViewNotification = false
    },
    close() {
      this.emit()
      this.isViewNotification = false
    },
    emit() {
      this.model = this.model.filter(function (element) {
        return element !== undefined
      })
      this.$emit('customRecipientList', this.model)
      this.$emit('chkboxWs', this.chkboxWs)
      this.$emit('chkboxPostComment', this.chkboxPostComment)
    },
    removeAll() {
      this.model = []
      this.chkboxWs = false
      this.chkboxPostComment = false
    },
    filter(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : '')
      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
  },
  computed: {
    isRequestAvailable() {
      return this.selectMember && this.selectMember !== null
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
    wsInfo() {
      return this.$store.getters.selectedWsInfo
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList && this.$store.getters.totalSectionList !== null
        ? this.$store.getters.totalSectionList
        : []
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex && this.$store.getters.sectionIndex !== null
        ? this.$store.getters.sectionIndex
        : 0
    },
    stId() {
      let stId
      if (this.totalSectionList.length > 0) stId = this.totalSectionList[this.sectionIndex].stId
      return stId
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    statusNoti() {
      let status

      if (this.model.length == 0 && !this.chkboxWs && !this.chkboxPostComment) {
        status = 'None'
      } else if (this.mtInfo.mtPermission == 'private') {
        !this.chkboxWs && this.chkboxPostComment && this.model.length == 0 ? (status = 'Default') : (status = 'Custom')
      } else if (this.mtInfo.mtPermission == 'workspace') {
        this.chkboxWs && this.chkboxPostComment && this.model.length == 0 ? (status = 'Default') : (status = 'Custom')
      } else {
        status = 'Custom'
      }

      return status
    },
    initialValueChkboxWs() {
      return this.mtInfo.mtPermission == 'private' ? false : true
    },
  },

  watch: {
    model(val, prev) {
      // console.log(val, prev)
      if (val.length === prev.length) return

      this.model = val.map((v) => {
        if (typeof v === 'string') {
          if (regExpTest('EMAIL', v)) {
            v = {
              userDisplayName: v,
              userEmail: v,
            }
            this.memberData.push(v)
          }
        }

        if (typeof v === 'object') {
          return v
        }
      })
      // console.log(this.model)
      // console.log(this.memberData)
    },
    isViewNotification: {
      handler: function (newVal) {
        if (newVal) {
          this.initialValue.model = this.model
          this.initialValue.chkboxWs = this.chkboxWs
          this.initialValue.chkboxPostComment = this.chkboxPostComment
        }
      },
      deep: true,
    },
    chkboxWs: {
      handler: function () {
        this.emit()
      },
    },
    chkboxPostComment: {
      handler: function () {
        this.emit()
      },
    },
  },
}
</script>

<style scoped>
.btn-noti >>> span {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-weight: 500;
}
.btn-text-status {
  color: #eee;
  font-size: 12px !important;
  font-weight: 300 !important;
}
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.dialog >>> .el-dialog {
  background: transparent;
}
.dialog >>> .el-dialog__body {
  background: #21343b !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dialog >>> .el-dialog__header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-left: 32px;
  background: #21343b !important;
}
.dialog >>> .el-dialog__title {
  color: white;
  font-weight: bold;
}
.dialog >>> .el-dialog__close {
  margin-right: 10px;
  background: #21343b !important;
}

.dialog-user-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}

.crown-icon {
  position: absolute;
  font-size: 20px;
  margin-left: 7px;
  bottom: calc(50% + 7px);
}
.logo {
  position: relative;
  border: 1px solid #43535e !important;
  margin-right: 2px;
  overflow: visible;
  cursor: default !important;
  z-index: 1;
}
.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-user-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: 250px;
}
.dialog-user-name {
  font-weight: 600;
  font-size: 12px;
  line-height: 35px;
  color: white;
  padding: 0px;
}

.container-find-user {
  border: none !important;
  background-color: #1a272e !important;
  color: white;
}
.container-content {
  background-color: #1a272e !important;
  border-radius: 10px;
}

.crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translate(6px, -11px);
}
.selected-crown {
  color: #ffc542;
  font-size: 15px;
  position: absolute;
  transform: translate(-26px, -9px);
}

.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.container-content >>> .v-input__slot {
  background: transparent !important;
  padding: 4px !important;
}
.container-content >>> input::placeholder {
  font-weight: 500;
  font-size: 14px !important;
}
.container-content >>> input {
  padding-top: 0px;
  font-weight: 500;
  font-size: 14px !important;
}
.container-checkbox >>> .v-input__slot {
  flex-direction: row-reverse;
}
.v-list {
  width: 550px;
  background-color: #1a272e;
}
.v-chip {
  margin-top: 6px;
  border-radius: 12px !important;
  background-color: #43535e !important;
}
.container-find-user >>> div[role='combobox'] {
  box-shadow: none !important;
}
.container-find-user >>> .v-select__selections {
  max-height: 130px;
  overflow-y: auto;
}
.container-combobox >>> .v-input__control {
  flex-direction: column-reverse;
}
kbd {
  background: #ddd !important;
  color: #1a272e !important;
  padding: 0.1em 0.4em !important;
}
</style>
